export const summarizeMessage = (message: string): string => {
  const maxLength = 30;
  let summarizedTitle = message.substring(0, maxLength);

  if (message.length > maxLength) {
    summarizedTitle += "...";
  }

  return summarizedTitle;
}